import type { FormFunnelFlowState } from "@portal/app/_components/formFunnel/types";
import type { PuckBlockProps } from "./types";

export type PageVisibilityPhase = "questions" | "loading" | "hosted" | "success";

export function pageVisibilityPhase(state: FormFunnelFlowState): PageVisibilityPhase {
  return state === "questions" || state === "loading" || state === "success" ? state : "hosted";
}

export function isPageContentVisible(
  when: PuckBlockProps["Visibility"]["when"],
  phase: PageVisibilityPhase,
  isFirstQuestion: boolean
) {
  return (
    when === "always" ||
    (when === "first-question" && phase === "questions" && isFirstQuestion) ||
    (when === "except-success" && phase !== "success") ||
    (when === "supporting" && phase !== "loading" && phase !== "success")
  );
}
